import { gql } from '@apollo/client'

export const APPOINTMENT_AVAILABILITY = gql`
  query AppointmentsQuery($id: ID!) {
    location(id: $id) {
      id
      name
      availableAppointments {
        id
        bookedAt
        end
        start
        provider {
          id
          name
        }
        appointmentType {
          id
          name
        }
      }
    }
  }
`
